import React, { useEffect, useRef } from 'react';

const Reveal = ({ as: Tag = 'div', className = '', delay = 0, children, ...props }) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || !('IntersectionObserver' in window) || window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) {
      node?.classList.add('is-visible');
      return undefined;
    }

    if (node.getBoundingClientRect().top < window.innerHeight) {
      node.classList.add('is-visible');
      return undefined;
    }
    node.classList.add('is-pending');
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          node.classList.add('is-visible');
          observer.unobserve(node);
        }
      },
      { threshold: 0.14, rootMargin: '0px 0px -4% 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${className}`.trim()}
      style={{ '--reveal-delay': `${delay}ms` }}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
